import { render, staticRenderFns } from "./controller.vue?vue&type=template&id=38e26b06&"
import script from "./controller.vue?vue&type=script&lang=js&"
export * from "./controller.vue?vue&type=script&lang=js&"
import style0 from "./controller.vue?vue&type=style&index=0&id=38e26b06&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports